import React from "react";
import {
  Button, DialogActions, DialogContent, Grid
} from '@mui/material';
import TextInput from "@/common/components/text-input/text-input";
import Dropdown from "@/common/components/dropdown/dropdown";
import SwitchInput from "@/common/components/switch-input/switch-input";
import AnimateButton from "@/from-theme/components/@extended/AnimateButton";
import { FormattedMessage } from 'react-intl';
import useCreateEditStateMaster from "./hooks/useCreateEditStateMaster";
import useGetCountryOptions from "@/common/hooks/useGetCountryMaster";
import PropTypes from "prop-types";
import { apiStatuses } from "@/store/api/constants";
import Spinner from "@/common/components/spinner/spinner";
import ErrorInPage from "@/common/components/error-in-page/error-in-page";


function CreateEditStateMaster({
  closeModal, activeEditId
}) {

  const { getCountryOptions, getCountryLoading } = useGetCountryOptions();
  const { values, formik, getEditStateMasterStatus, saveStateMasterStatus, updateStateMasterStatus,
    getEditStateMasterErrMsg } = useCreateEditStateMaster(activeEditId);

  const isPending = [saveStateMasterStatus, updateStateMasterStatus].includes(apiStatuses.pending);

  const {
    stateName, countryId, activeStatus
  } = values;

  return (
    <>
      {
        getEditStateMasterStatus === apiStatuses.pending && activeEditId
        && <Spinner />
      }

      {getEditStateMasterStatus === apiStatuses.rejected && activeEditId && (
        <ErrorInPage message={getEditStateMasterErrMsg} />
      )}

      {(getEditStateMasterStatus === apiStatuses.succeeded || !activeEditId) &&
        <form onSubmit={formik.handleSubmit}>
          <DialogContent dividers>
            <Grid container spacing={1.25}>
              
              <Grid item xs={12} sm={6} md={4} lg={6}>
                <Dropdown
                  options={getCountryOptions}
                  loading={getCountryLoading}
                  placeholder="country-name"
                  inputLabel="country-name"
                  value={countryId}
                  formik={formik}
                  name="countryId"
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={6}>
                <TextInput
                  placeholder="state-name" size="small" fullWidth
                  value={stateName}
                  inputLabel="state-name"
                  formik={formik}
                  name="stateName"
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={6}>
                <SwitchInput
                  inputLabel="activeStatus"
                  leftLabel="inactive"
                  rightLabel="active"
                  value={activeStatus}
                  formik={formik}
                  name="activeStatus"
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button color="error" onClick={closeModal} variant="outlined" disabled={isPending} 
             sx={{ mr: 1 }}>
              <FormattedMessage id={"cancel"} />
            </Button>
            <AnimateButton>
              <Button type="submit" variant="contained" disabled={isPending} sx={{ mr: 1 }}>
                <FormattedMessage id={"save"} />
              </Button>
            </AnimateButton>
          </DialogActions>
        </form>
      }
    </>
  )
}

CreateEditStateMaster.propTypes = {
  closeModal: PropTypes.func.isRequired,
  activeEditId: PropTypes.bool,
};

CreateEditStateMaster.defaultProps = {
  activeEditId: 0,
};

export default CreateEditStateMaster;